import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { WorkMaterialCategory } from './work-material-category.interface';
import { WorkMaterialCategoryService } from './work-material-category.service';

const service = new WorkMaterialCategoryService();

export interface WorkMaterialCategoryState {}

const WorkMaterialCategoryStore: Module<WorkMaterialCategoryState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getWorkMaterialCategories(context, payload: { employerId: number; query?: LocationQuery }) {
         const workMaterialCategoriesOverview = await service.getWorkMaterialCategories(payload.employerId, payload.query);
         return workMaterialCategoriesOverview.data;
      },
      async getWorkMaterialCategory(context, payload: { employerId: number; workMaterialCategoryId: number; query?: LocationQuery }) {
         const response = await service.getWorkMaterialCategory(payload.employerId, payload.workMaterialCategoryId, payload.query);
         return response.data;
      },
      async createWorkMaterialCategory(context, payload: { employerId: number; workMaterialCategory: WorkMaterialCategory }) {
         const response = await service.postWorkMaterialCategory(payload.employerId, payload.workMaterialCategory);
         return response.data;
      },
      async putWorkMaterialCategory(
         context,
         payload: { employerId: number; workMaterialCategoryId: number; workMaterialCategory: WorkMaterialCategory },
      ) {
         const { employerId, workMaterialCategoryId, workMaterialCategory } = payload;
         const response = await service.putWorkMaterialCategory(employerId, workMaterialCategoryId, workMaterialCategory);
         return response.data;
      },
      async deleteWorkMaterialCategory(context, payload: { employerId: number; workMaterialCategoryId: number }) {
         return await service.getWorkMaterialCategory(payload.employerId, payload.workMaterialCategoryId);
      },
   },
};

export default WorkMaterialCategoryStore;
